module.exports = __webpack_public_path__ + "static/img/LMP_logo.31c3573.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/logos/1x/LMP_logo.png
// module id = BjTV
// module chunks = 1